export default __webpack_public_path__ + "static/media/Vistasis_B.b37f4d07.png";